// Safely capitalize the first letter of a string; returns '' for empty/nullish input so
// display code never crashes on blank data. The old inline `field[0].toUpperCase()` pattern
// threw 'Cannot read properties of undefined (reading toUpperCase)' when the field was ''.
export const capitalize = (value?: string | null): string =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
